<template>
	<div>
		<div class="multiple">
			<div class="child-div">时间区间</div>
			<RadioGroup v-model="timePeriod">
				<Radio label="0"><span>不限</span></Radio>
				<Radio label="1"><span>今日</span></Radio>
				<Radio label="2"><span>昨日</span></Radio>
				<Radio label="3"><span>本周</span></Radio>
				<Radio label="4"><span>上周</span></Radio>
				<Radio label="5"><span>本月</span></Radio>
				<Radio label="6"><span>上月</span></Radio>
				<Radio label="7"><span>自定义</span></Radio>
				<DatePicker :value="timePeriodDate" @on-change="timePeriodDateChange" type="daterange"
					placeholder="选择日期" style="width: 200px"></DatePicker>
			</RadioGroup>
		</div>
		<div class="multiple" style="margin-bottom: 20px;">
			<div class="child-div">搜索条件</div>
			<Input placeholder="搜索登录名称" v-model="name" style="width: 150px;margin-left: 20px;">
			</Input>
			<Input placeholder="搜索ip" v-model="ip" style="width: 150px;margin-left: 20px;">
			</Input>
			<Input placeholder="搜索城市/备注" v-model="city" style="width: 150px;margin-left: 20px;">
			</Input>
			<Select v-model="shop_id" style="width:150px;margin-left: 20px;" clearable placeholder="分公司" >
				<Option v-for="item in shopList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
			<Select v-model="follow_department" style="width:150px;margin-left: 20px;" clearable placeholder="团队" >
				<Option v-for="item in departmentList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
			<Select v-model="follow_uid" style="width:150px;margin-left: 20px;" clearable placeholder="个人">
				<Option v-for="item in teamList" :value="item.value" :key="item.value">{{ item.label }}</Option>
			</Select>
			<Select v-model="login_type" style="width:150px;margin-left: 20px;" clearable placeholder="登录类型">
				<Option  value="0" >登录成功</Option>
				<Option  value="0" >登录成功</Option>
				<Option  value="0" >登录成功</Option>
				<Option  value="4" >登录失败</Option>
			</Select>
			<Button  type="primary" style="margin-left: 20px;" @click="mySearch">搜索</Button>
			<Button type="primary" style="margin-left: 20px;" @click="initSearch">重置</Button>
		</div>
		<Table border :columns="columns" :data="LoginLogList"></Table>
		<div>
			<Page show-total :total="count" show-sizer :page-size="pageSize" :page-size-opts="pageSizeOpts"
				:current="page" @on-change="changePage" @on-page-size-change="changeSize" size="small" show-elevator />
		</div>
	</div>
</template>

<script>
	import {
		getLoginLogList
	} from "../../api/admin";
	import {getAllShop} from "../../api/runSet";
	import {
		getTeamList,
		getDepartmentList,
		getUserListByDepartmentId,
		getDepartmentListByShopId
	} from '@/api/user'
	import {
		mapGetters,
		mapActions
	} from "vuex";
	export default {
		name: "login_log",
		data() {
			return {
				columns: [{
						title: "排名",
						type: "index",
						align: 'center'
					},
					{
						title: "用户名",
						key: "name",
						align: 'center'
					},
					{
						title: "公司",
						key: "company_name",
						align: 'center'
					},
					{
						title: "登录ip",
						key: "ip",
						align: 'center'
					},
					{
						title: "登录时间",
						key: "login_time",
						align: 'center'
					},
					{
						title: "登录城市",
						key: "address",
						align: 'center'
					},
					{
						title: "浏览器",
						key: "browser",
						align: 'center'
					},
					{
						title: "系统",
						key: "os",
						align: 'center'
					},
					{
						title: "备注",
						key: "remark",
						align: 'center'
					},
				],
				name:'',
				ip:'',
				city:'',
				login_type:'',
				timePeriod: '',
				timePeriodDate: [],
				LoginLogList: [],
				page: 1,
				pageSize: 10,
				editStatus: 0,
				pageSizeOpts: [10, 50, 100, 500],
				count: 0,
				shop_id:'',
				follow_uid:'',
				follow_department:'',
				shopList:[],
				teamList:[],
				departmentList:[],
				order_type: 'desc'
			};
		},
		computed: {
			...mapGetters(['token', 'userInfo'])
		},
		mounted() {
			this.loadData();
			this.getList();
		},
		methods: {
			...mapActions([
				'handleLogOut',
				'getUserInfo',
			]),
			changePage(e) {
				this.page = e;
				this.getList();
			},
			changeSize(e) {
				this.pageSize = e;
				this.getList();
			},
			mySearch() {
				this.page = 1;
				this.getList();
			},
			timePeriodDateChange(e) {
				this.timePeriodDate = e;
				this.getList();
			},
			async loadData() {
				let that = this;
				var data = {
					token: this.token,
					only_customer: 1
				};
				var data = {
					token: that.token,
					getSelf: 1,
				};
				var res = await getTeamList(that, data);
				if (res.code == 1) {
					that.teamList = res.data.list;
				}
				res = await getDepartmentList(that, data);
				if (res.code == 1) {
					that.departmentList = res.data.list;
				}
				res = await getAllShop(that, data);
				that.shopList = res.data.list;
			},
			initSearch() {
				this.name = '';
				this.ip = '';
				this.page = 1;
				this.pageSize = 10;
				this.city = [];
				this.shop_id = '';
				this.follow_department='';
				this.follow_uid = '';
				this.login_type = '';
				this.timePeriod = '';
				this.timePeriodDate = [];
				this.getList();
			},
			async getList() {
				let that = this;
				let data = {}
				data.page = that.page
				data.pageSize = that.pageSize
				data.name = that.name
				data.ip = that.ip
				data.city = that.city
				data.token = that.token;
				data.shop_id = that.shop_id;
				data.timePeriod =that.timePeriod
				data.timePeriodDate = that.timePeriodDate
				data.order_type = that.order_type;
				data.follow_uid = that.follow_uid;
				data.follow_department = that.follow_department;
				let res = await getLoginLogList(that, data);
				that.LoginLogList = res.data.list;
				that.count = res.count;
			},
		},
	};
</script>

<style lang="less" scoped>
	.red {
		color: red;
	}

	.multiple {
		display: flex;
		justify-content: left;
		margin-top: 10px;
		align-items: center;

		.child-div {
			width: 70px;
			height: 20px;
			font-weight: bold;
			margin-right: 30px;
			text-align-last: justify;
		}
	}

	.hong {
		color: #F56171;
		font-weight: bold;
	}

	.lan {
		color: #124386;
		font-weight: bold;
	}

	.sousuo {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.yl-flex {
		display: flex;
	}

	.flex_between {
		align-items: flex-start;
		display: flex;
		justify-content: space-between;
		margin-bottom: 10px;
	}

	.ivu-table-header thead tr th {
		text-align: center !important;
	}

	.ivu-table-cell {
		padding-left: 2px;
		padding-right: 2px;
		text-align: center;
	}

	/deep/ .ivu-table th {
		background: #277dd3;
		color: white;
	}

	/deep/ .ivu-table .table-blue-row td {
		color: #ff6699;
	}

	/deep/ .ivu-table .table-yellow-row td {
		color: #aaaa00;
	}

	/deep/ .ivu-table .table-black-row td {
		color: black;
	}
</style>